import cloneDeep from "lodash/cloneDeep";
import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

import { CategoriesApi } from "../api";
import { safeStorage } from "./ssrStorage";

const initialState = {
	categoryInfo: {},
	homepageInfo: [],
	sort: "our favourites",
	availableSorts: ["our favourites", "newest", "price: low to high", "price: high to low"],
	structuredData: {},
	currentInternationalCategory: "",
};

interface CategoriesState {
	categoryInfo: any;
	homepageInfo: any[];
	sort: string;
	availableSorts: string[];
	structuredData: any;
	currentInternationalCategory: string;
	GetHomepage: () => Promise<{ content_blocks: any[]; meta: any }>;
	GetCategory: (id: string) => Promise<{ category: any; structuredData: any }>;
	ResetCategoryInfo: () => void;
	SetActiveSort: (sort: string) => void;
	SetCurrentInternationalCategory: (internationalCategory: string) => void;
}

const useCategoriesStore = create<CategoriesState>()(
	persist(
		devtools((set, get) => ({
			...cloneDeep(initialState), // Use deep clone for initial state
			async GetHomepage() {
				const { content_blocks, meta } = await CategoriesApi.getContentBlocks();
				set({ homepageInfo: content_blocks });
				return { content_blocks, meta };
			},
			async GetCategory(id) {
				const { category, structuredData } = await CategoriesApi.getCategory(id);
				set({ categoryInfo: category, structuredData: structuredData });
				return { category, structuredData };
			},
			ResetCategoryInfo() {
				set({ categoryInfo: cloneDeep(initialState.categoryInfo) }); // Deep clone to reset
				return {};
			},
			SetActiveSort(sort) {
				set({ sort: sort });
			},
			SetCurrentInternationalCategory(internationalCategory) {
				set({ currentInternationalCategory: internationalCategory });
			},
		})),
		{
			name: "category-store",
			storage: safeStorage,
		},
	),
);

export { useCategoriesStore };
